<template>
	<div class="page">
		<top-header></top-header>
		<b-container fluid >
		<b-row class="mb-3">	
			<top-nevleft></top-nevleft>
			
		 <b-col class="p-0">
		 <!--<b-row class="breadcrumbrow mt-1 m-0">				
			<b-col>
			 <h5 class="text-center">Admin Dashboard</h5>
			</b-col>				
		 </b-row> -->
		 
		<!-- <b-container fluid>
			<b-row class="mt-3 mb-2">
				<b-col class="col-md-6 col-sm-6 col-xs-6 text-left">
					<h3>Product Requests</h3>
				</b-col>
				<b-col class="col-md-6 col-sm-6 col-xs-6 text-right">
					<b-button variant="dark" pill  @click="downloadcsv()"><b-icon class="mr-2" icon="download" aria-hidden="true"></b-icon>Export</b-button>
				</b-col>
			</b-row>
		</b-container> -->
		<b-container fluid class="mt-3 mb-2">
			<b-row>
				<b-col class="col-md-12 col-sm-12 col-xs-12">
					<div class="container-box">
					
					
						<b-row class="mt-4 px-3">
							<b-col lg="6" class="text-left">
								 <b-button size="sm ml-3 mr-2" @click="selectAllRows">Select all</b-button> <b-button size="sm mr-2" @click="clearSelected">Clear selected</b-button>
							</b-col>
							<b-col lg="6"  class="text-right">
								 <b-button size="sm mr-2" @click="settoActiveproduct">Active Product</b-button>
							</b-col>
						</b-row>
					
						<b-row class="mt-4 px-3">
							<b-col lg="2" class="text-left">
								<span class="mr-2">Show</span>
								<b-form-select v-model="perPage" id="perPageSelect" :options="pageOptions" size="sm" class="w-100">
								</b-form-select>
								
							</b-col>
							<b-col lg="2" class="text-left">
								<span class="mr-2">Brand</span>
								<b-form-select v-model="reg_brand" required size="sm">
									<b-form-select-option value="null">All Brand</b-form-select-option>
									<b-form-select-option v-for="sellerRor in sellerList" :value="sellerRor.brand_name"  :key="sellerRor.user_id" >{{sellerRor.brand_name+' ('+sellerRor.productCount+')'}}</b-form-select-option>
									
								</b-form-select>
							</b-col>
							<b-col lg="2" class="text-left">
								<b-button pill variant="primary" class="mt-4" @click="loadData()" size="sm">Submit</b-button>
							</b-col>
							
							<b-col lg="2"  >
								&nbsp;
							</b-col>
							
							<b-col lg="4"  >
								<b-form-group label="Filter" label-size="sm" label-for="filterInput" class="mb-0">
									<b-input-group size="sm" class="m-0">
										<b-form-input v-model="filter" type="search" id="filterInput" placeholder="Type to Search">
										</b-form-input>
										<b-input-group-append>
											<b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
										</b-input-group-append>
									</b-input-group>
								</b-form-group>
							</b-col>
						</b-row>
						<b-row class="px-3 pt-3">
							<b-col lg="12">
								<b-table show-empty sticky-header small striped outlined id="my-table" stacked="md" :items="records" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :filterIncludedFields="filterOn" :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered" 
								:select-mode="selectMode"
								ref="selectableTable"
								selectable @row-selected="onRowSelected"> 
								
									<!-- <template #cell(selected)="{ rowSelected }">
									
									<template v-if="rowSelected">
									  <span aria-hidden="true">&check;</span>
									  <span class="sr-only">Selected</span>
									</template>
									<template v-else>
									  <span aria-hidden="true">&nbsp;</span>
									  <span class="sr-only">Not selected</span>
									</template>
								  </template> -->
								  
								  <template v-slot:cell(selected)="{ rowSelected }">
										<template v-if="rowSelected">
									  <span aria-hidden="true">&check;</span>
									  <span class="sr-only">Selected</span>
									</template>
									<template v-else>
									  <span aria-hidden="true">&nbsp;</span>
									  <span class="sr-only">Not selected</span>
									</template>
								</template>
								
								
								
									<template v-slot:cell(status)="row">
										<b-badge pill variant="warning" v-if="row.value == 0">WAITING</b-badge>
										<b-badge pill variant="danger" v-else-if="row.value == 1">ACTIVE</b-badge>
										<b-badge pill variant="success" v-else>REJECTED</b-badge>
									</template>
                                    <template v-slot:cell(price)="row">
										<span v-html="row.value"></span>
									</template>
                                    <!--<template v-slot:cell(rating)="row">
										<b-form-rating v-model="row.value" inline no-border readonly show-value show-value-max size="sm" variant="info"></b-form-rating>
									</template>-->
                                    <template v-slot:cell(thumbnail)="row">
                                        <b-img v-bind="thumbnailProps" rounded alt="" v-if="row.value==''" src="../../assets/icons/blank.svg">{{row}}</b-img>
                                       <!-- <b-img v-bind="thumbnailProps" rounded alt="" v-else :src="$root.MEDIAPATH+'products/'+(row.value).replace('_rg','_th')">{{row}}</b-img> -->
                                        <b-img v-bind="thumbnailProps" rounded alt="" v-else :src="row.value.replace('_rg','_th')">{{row}}</b-img>
                                    </template>
									<template v-slot:cell(actions)="row">
										<b-button pill variant="outline-primary" class="mr-1 icon-btn" @click="updateStatus(row.item, 1)"><b-icon icon="check2" font-scale="1.8" ></b-icon></b-button>
										<b-button pill variant="outline-danger" class="mr-1 icon-btn" @click="deleteProduct(row.item, 2)"><b-icon icon="trash" font-scale="1.6" ></b-icon></b-button>
										
										
										<b-button pill variant="outline-primary" class="mr-1 icon-btn" @click="$root.previewproduct(row.item, row.index)"><i class="fa fa-eye" aria-hidden="true"></i></b-button> 
									</template>
								</b-table>
							</b-col>
						</b-row>
						
						<b-row class="px-3">
							<b-col lg="6" class="text-left">
								<span class="mr-2">Showing {{currentPage}} to {{(perPage>records.length)?records.length:perPage}} of {{records.length}} entries</span>
							</b-col>
							<b-col lg="3" offset-md="3">
								<b-pagination v-model="currentPage" pills :total-rows="totalRows" :per-page="perPage" align="right" size="sm" prev-text="Prev" next-text="Next" first-number last-number></b-pagination>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>

			
			<b-modal id="my-model" :title="(selectedItem.id > 0)?'Edit Product':'Add Product'" size="lg" ok-only @hidden="resetSelectedItem" @ok="modalSubmit">
				<form ref="form" @submit.stop.prevent="handleSubmit">
					<b-container fluid>
						<b-tabs content-class="mt-3" small>
                            <b-tab title="Product" href="#product">
                                <b-row class="mb-1">
									<b-col cols="12">
										<b-row class="mb-3">
											<b-col cols="3" class="text-right"><label class="font-sm">Product Title</label></b-col>
											<b-col><b-form-input v-model="selectedItem.title" size="sm" required></b-form-input></b-col>
										</b-row>
										<b-row class="mb-3">
											<b-col cols="3" class="text-right"><label class="font-sm">Short Description</label></b-col>
											<b-col><b-form-textarea v-model="selectedItem.short_description" size="sm" rows="3" required></b-form-textarea></b-col>
										</b-row>
										<b-row class="mb-3">
											<b-col cols="3" class="text-right"><label class="font-sm">Description</label></b-col>
											<b-col><b-form-textarea v-model="selectedItem.description" size="sm" rows="4" required></b-form-textarea></b-col>
										</b-row>
										<b-row class="mb-3">
											<b-col cols="3" class="text-right"><label class="font-sm">Product Category</label></b-col>
											<b-col><b-form-input v-model="selectedItem.category" size="sm" required></b-form-input></b-col>
										</b-row>
										<b-row class="mb-3">
											<b-col cols="3" class="text-right"><label class="font-sm">Minimum Qty</label></b-col>
											<b-col><b-form-input v-model="selectedItem.product_data.min_qty" required size="sm" placeholder="eq. 5"></b-form-input></b-col>
										</b-row>
									</b-col>
                                </b-row>
                            </b-tab>
                            <b-tab title="Size & Weight" to="#category">
								<b-row class="mb-1">
									<b-col cols="12">
										<b-row class="mb-3">
											<b-col cols="3" class="text-right"><label class="font-sm">Size </label></b-col>
											<b-col class="flex-row"><span class="font-md pt-1 pr-1">Length:</span><b-form-input v-model="selectedItem.product_data.size_length" required size="sm"></b-form-input></b-col>
											<b-col class="flex-row"><span class="font-md pt-1 pr-1">Width:</span><b-form-input v-model="selectedItem.product_data.size_width" required size="sm"></b-form-input></b-col>
											<b-col class="flex-row"><span class="font-md pt-1 pr-1">Height:</span><b-form-input v-model="selectedItem.product_data.size_height" required size="sm"></b-form-input></b-col>
										</b-row>
										<b-row class="mb-3">
											<b-col cols="3" class="text-right"><label class="font-sm">Weight</label></b-col>
											<b-col><b-form-input v-model="selectedItem.product_data.weight" required size="sm"></b-form-input></b-col>
										</b-row>
									</b-col>
								</b-row>
							</b-tab>
							<b-tab title="Images" to="#images">
								<b-row class="mb-1">
									<b-col cols="12">
										<b-row class="mb-3">
											<b-col cols="3" class="text-right"><label class="font-sm">Product Image</label></b-col>
											<b-col>
												<b-form-file type="file" v-model="product_inf.product_image" accept=".jpeg,.jpg,.png" size="sm" placeholder="Choose a Image"></b-form-file>
												<b-form-text id="password-help-block">{{selectedItem.image}}</b-form-text>
											</b-col>
										</b-row>
									</b-col>
								</b-row>
							</b-tab>
							<b-tab title="Price" to="#price">
								<b-row class="mb-1">
									<b-col cols="12">
										<b-row class="mb-3">
											<b-col cols="3" class="text-right"><label class="font-sm">Price</label></b-col>
											<b-col><b-form-input v-model="selectedItem.price" required size="sm" placeholder="eq. 19.99"></b-form-input></b-col>
										</b-row>
										<b-row class="mb-3">
											<b-col cols="3" class="text-right"><label class="font-sm">Special Price</label></b-col>
											<b-col><b-form-input v-model="selectedItem.special_price" required size="sm" placeholder="eq. 19.99"></b-form-input></b-col>
										</b-row>
									</b-col>
								</b-row>
							</b-tab>
							<b-tab title="Tier Price" href="#product">
								<b-row class="mb-1">
									<b-col cols="2">
									</b-col>
									<b-col cols="7">
										<b-row>
											<b-col>
												<b-row>
													<b-col cols="2">
														<label class="font-sm">S.No.</label>
													</b-col>
													<b-col cols="3">
														<label class="font-sm">Min. Qty</label>
													</b-col>
													<b-col cols="3">
														<label class="font-sm">Price</label>
													</b-col>
													<b-col cols="2">
														<label class="font-sm">Delete</label>
													</b-col>
												</b-row>
												<b-row v-for="(item, index) in selectedItem.tier_price" :key="item.id" class="mb-2">
													<b-col cols="2">
														<label class="font-sm">{{index+1}}</label>
													</b-col>
													<b-col cols="3">
														<b-form-input v-model="item.min_qty" required size="sm" placeholder="0"></b-form-input>
													</b-col>
													<b-col cols="3">
														<b-form-input v-model="item.price" required size="sm" placeholder="0.00"></b-form-input>
													</b-col>
													<b-col cols="2">
														<b-button pill variant="outline-danger" class="mr-1 icon-btn" @click="removeTierPrice(index)" size="sm"><b-icon scale="1.2" icon="trash" aria-hidden="true"></b-icon></b-button>
													</b-col>
												</b-row>
											</b-col>
										</b-row>
									</b-col>
									<b-col cols="3"><b-button size="sm" variant="danger" @click="addTierPrice()" class="float-right">Add Tier Price</b-button></b-col>
								</b-row>
							</b-tab>
							<b-tab title="Commission" href="#product">
								<b-row class="mb-1">
									<b-col cols="12">
										<b-row class="mb-3">
											<b-col cols="3" class="text-right"><label class="font-sm">Commission</label></b-col>
											<b-col>
												<b-form-input v-model="selectedItem.commission" required size="sm" placeholder="0"></b-form-input>
												<small>Min commission 10%</small>
											</b-col>
										</b-row>
									</b-col>
								</b-row>
							</b-tab>
						</b-tabs>
						
					</b-container>
				</form>
				<template v-slot:modal-footer="{ ok, close }">
					<b-button size="sm" variant="danger" @click="close()">Cancel</b-button>
					<b-button size="sm" variant="success" @click="ok()">{{(selectedItem.id > 0)?'Update':'Submit'}}</b-button>
				</template>
			</b-modal>
		
		</b-container>
		<transition name="fade">
			<b-row v-if="loading" class="loading" style="position: absolute; top:0px; left:0px; right:0px; bottom:0px; z-index: 1000; background-color: rgba(0,0,0,0.4);" align-v="center" align-h="center">
				<b-spinner label="Busy" variant="light"></b-spinner>
			</b-row>
		</transition>
		
		<top-footer></top-footer>
	</b-col>
	</b-row>
		
	</b-container>
	<product-preview :productviewlink="$root.productviewlink"></product-preview>
	</div>
	
</template>
<script>
//import Header from "@/components/admin/Header.vue";
import Header from "@/components/header.vue";
import Footer from "@/components/footer-admin.vue";
import TreeviewPage from "@/components/admin/nevleft.vue";
import Productpreview from "@/components/product-preview.vue";
export default {
	name: 'Devices',
	components: {
		"top-header": Header,
		"top-footer": Footer,
		"top-nevleft": TreeviewPage,
		"product-preview": Productpreview,
	},
	mounted(){
		var self = this;
		Object.assign(self.selectedItem, self.emptyItem);
		this.initload();
	},
	data() {
		return{
            loading: true, 
            thumbnailProps: { blank: false, width: 60, height: 60, class: 'm1' },
            product_inf: {},
			/*product_glb: '',*/
			model_maps: {},
			recordUrl: this.$root.WEBAPI+'secureapi/product-rejected',
			updateUrl: this.$root.WEBAPI+'secureapi/productstatus-updateUnapprove',
			deleteUrl: this.$root.WEBAPI+'secureapi/deleteProduct',
			updateBulkUrl: this.$root.WEBAPI+'secureapi/productstatus-updateUnapprovebulk',
			records: [],
			categoryOptions: [],
			breadcrumb: [
				{
					text: 'Home',
					href: '/'
				},
				{
					text: 'Products',
					active: true
				}
			],
			fields: [
                { key: 'Selected',label: 'Selected'},
                { key: 'id', label: 'ID'},
                { key: 'seller', label: 'Seller'},
                /* { key: 'rating', label: 'Seller Rating'},*/
				{ key: 'title', label: 'Title'},
				{ key: 'category', label: 'category' },
				{ key: 'thumbnail', label: 'Thumbnail',
					formatter: (value, key, item) => { 
						return item.image;
					}
				},
				{ key: 'price', label: 'Price', class: 'text-right',
					formatter: (value, key, item) => { 
							
							if(item.price>item.special_price && item.special_price!=null ){
								var special_price = item.special_price>0 || item.special_price!=null?item.special_price:0;
								return this.$root.currency()+this.$root.tofixed(special_price,2)+" <del>"+this.$root.currency()+this.$root.tofixed(item.price,2)+"</del>";
							}else{
								return this.$root.currency()+this.$root.tofixed(item.price,2);
							}
						

						
					},
				},
				{ key: 'commission', label: 'Commission', class: 'text-right',
					formatter: (value) => { 
						if(value == '' || value == 0){
							return value = 'N/A';
						}
						return value+'%';
					},
				},
				{ key: 'status', label: 'Status' },
				{ key: 'actions', label: 'Actions', 'extra': 1, class: 'text-right' }
			],
			totalRows: 1,
			currentPage: 1,
			pageOptions: [10, 20, 50, 100],
			perPage: 10,
			sortBy: '',
			sortDesc: false,
			sortDirection: 'asc',
			filter: null,
			filterOn: [],
			selectedItem: {product_data:{}, tier_price:[]},
			emptyItem: {
				id: 0,
				product_id: '',
				title: '',
				short_description: '',
				description: '',
				sku: '',
				category: '',
				price: '',
				special_price: '',
				product_data:{},
				tier_price: [],
                status: 0
			},
			counterindex:1,
			 selectMode: 'multi',
			 selected: [],
			 sellerList: [],
			 reg_brand:null,
		};
	},
	methods: {
		onRowSelected(items) {
			this.selected = items
		  },
		  selectAllRows() {
			this.$refs.selectableTable.selectAllRows()
		  },
		  clearSelected() {
			this.$refs.selectableTable.clearSelected()
		  },
		removeTierPrice(i){
			this.selectedItem.tier_price.splice(i,1);
		},
		addTierPrice(){
			console.log(JSON.stringify(this.selectedItem.tier_price));
			var d = new Date();
			this.selectedItem.tier_price.push({'id':d.getTime(), 'min_qty':0, 'price':0});
		},
		showAddModal(){
			this.selectedItem = Object.assign({}, this.emptyItem);
			this.$root.$emit('bv::show::modal', 'my-model');
		},
		showUpdateModal(item, index, button) {
			this.selectedItem = Object.assign({}, item);
			if(item.product_data){
				this.selectedItem.product_data = JSON.parse(item.product_data);
			}
			if(item.tier_price){
				this.selectedItem.tier_price = JSON.parse(item.tier_price);
			}
			this.$root.$emit('bv::show::modal', 'my-model', button)
		},
		
		updateStatus(item, status){
			var self = this;
			this.$bvModal.msgBoxConfirm('Please confirm that you want to update product!.', {
				title: 'Please Confirm',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'YES',
				cancelTitle: 'NO',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			})
			.then(value => {
				if(value == true){
					self.axios.post(self.updateUrl, {
						accesskey: self.$session.get('access_key'),
                        product_id: item.product_id,
                        status: status
					})
					.then(function (response) {
						if(response.data.error == 0 || response.data.error == '0'){
							self.$bvToast.toast(response.data.message, {
								title: 'Update Status',
								toaster: 'b-toaster-bottom-right',
								autoHideDelay: 5000,
								variant: 'warning',
								solid: true,
								appendToast: true
							});
							self.initload();
						}
						
					})
					.catch(function (error) {
						alert(error);
					});
				}else{
					//alert('no '+item.id);
				}
			})
			.catch(err => {
				// An error occurred
				console.log(err);
			})
		},deleteProduct(item, status){
			var self = this;
			this.$bvModal.msgBoxConfirm('Delete product permanently!. Please confirm', {
				title: 'Please Confirm',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'YES',
				cancelTitle: 'NO',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			})
			.then(value => {
				if(value == true){
					self.axios.post(self.deleteUrl, {
						accesskey: self.$session.get('access_key'),
                        product_id: item.product_id,
                        status: status
					})
					.then(function (response) {
						if(response.data.error == 0 || response.data.error == '0'){
							self.$bvToast.toast(response.data.message, {
								title: 'Update Status',
								toaster: 'b-toaster-bottom-right',
								autoHideDelay: 5000,
								variant: 'warning',
								solid: true,
								appendToast: true
							});
							self.initload();
						}
						
					})
					.catch(function (error) {
						alert(error);
					});
				}else{
					//alert('no '+item.id);
				}
			})
			.catch(err => {
				// An error occurred
				console.log(err);
			})
		},
		settoActiveproduct(){
			var self = this;
			this.$bvModal.msgBoxConfirm('Please confirm that you want to approve all product!.', {
				title: 'Please Confirm',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'YES',
				cancelTitle: 'NO',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			})
			.then(value => {
				if(value == true){
					self.axios.post(self.updateBulkUrl, {
						accesskey: self.$session.get('access_key'),
                        product_id: self.selected,
                        status: 1
					})
					.then(function (response) {
						if(response.data.error == 0 || response.data.error == '0'){
							self.$bvToast.toast(response.data.message, {
								title: 'Update Status',
								toaster: 'b-toaster-bottom-right',
								autoHideDelay: 5000,
								variant: 'warning',
								solid: true,
								appendToast: true
							});
							self.initload();
						}else{
							self.$bvToast.toast(response.data.message, {
									title: 'Update Status',
									toaster: 'b-toaster-bottom-right',
									autoHideDelay: 5000,
									variant: 'warning',
									solid: true,
									appendToast: true
								});
						
						}
						
					})
					.catch(function (error) {
						alert(error);
					});
				}else{
					//alert('no '+item.id);
				}
			})
			.catch(err => {
				// An error occurred
				console.log(err);
			})
		},
		modalSubmit(bvModalEvt){
			var self = this;
			self.loading = true;
			bvModalEvt.preventDefault();
			var submitUrl = "";
			if(self.selectedItem.id == 0){
				submitUrl = self.insertUrl;
			}else{
				submitUrl = self.updateUrl;
            }

            let formData = new FormData();
            formData.append('imagefile', this.product_inf.product_image);
			formData.append('data', JSON.stringify(this.selectedItem));
            formData.append('accesskey', this.$session.get('access_key'));

            self.axios.post(submitUrl, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.$bvModal.hide('my-model');
					self.$bvToast.toast(response.data.message, {
						title: 'Status',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'warning',
						solid: true,
						appendToast: true
					});
					self.initload();
				}
				
			})
			.catch(function (error) {
				alert(error);
			});
		},
		
		

		resetSelectedItem(){
			var self = this;
			self.selectedItem = Object.assign({}, self.emptyItem);
		},
		initload(){
			var self = this;
			
			self.axios.post(self.recordUrl, {
				accesskey: self.$session.get('access_key')
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.records = response.data.result.products;
					self.sellerList = response.data.result.sellerList;
					self.loading = false;
					self.totalRows = self.records.length;
				}else if(response.data.error == 9){
					self.$root.forceLogout(response.data.message);
				}
				//setTimeout(self.initload, 1000*30);
			})
			.catch(function (error) {
				alert(error);
			});
			//alert('login '+self.email+" "+self.password);
		},
		loadData(){
			var self = this;
			
			self.axios.post(self.recordUrl, {
				accesskey: self.$session.get('access_key'),
				brandName: self.reg_brand
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.records = response.data.result.products;
					self.sellerList = response.data.result.sellerList;
					self.loading = false;
					self.totalRows = self.records.length;
				}else if(response.data.error == 9){
					self.$root.forceLogout(response.data.message);
				}
				//setTimeout(self.initload, 1000*30);
			})
			.catch(function (error) {
				alert(error);
			});
			
			
		},
		/*filtercategory(records){
			var filterarr = new Array();
			records.forEach(function(row){
				var dataarr = new Array();
				self.fields.forEach(function(field){
					if(field.key != 'extra'){
						dataarr.push(row[field.key]);
					}
				});
				finalarr.push(dataarr);
			});
		},*/
		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length
			this.currentPage = 1
		},
		downloadcsv(){
			var self = this;
			var header = new Array()
			self.fields.forEach(function(item){
				if(!item.extra){
					header.push(item.label);
				}
			});
			
			//var d = table.rows().data();
			var finalarr = new Array();
			finalarr.push(header);
			self.records.forEach(function(row){
				var dataarr = new Array();
				self.fields.forEach(function(field){
					if(field.key != 'extra'){
						dataarr.push(row[field.key]);
					}
				});
				finalarr.push(dataarr);
			});
			
			let csvContent = "data:text/csv;charset=utf-8," 
			+ finalarr.map(e => e.join(",")).join("\n");

			var encodedUri = encodeURI(csvContent);
			var link = document.createElement("a");
			link.setAttribute("href", encodedUri);
			link.setAttribute("download", "zone_report.csv");
			document.body.appendChild(link); // Required for FF

			link.click();
		}
	}
}
</script>
<style>
</style>